import { render, staticRenderFns } from "./OrderBoardCard.vue?vue&type=template&id=6fbe6b55&scoped=true&"
import script from "./OrderBoardCard.vue?vue&type=script&lang=js&"
export * from "./OrderBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoardCard.vue?vue&type=style&index=0&id=6fbe6b55&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe6b55",
  null
  
)

export default component.exports